import { useState } from 'react';

import { Alert } from '@cobliteam/ui/components';
import { Button, Dialog, Typography } from '@cobliteam/ui/components';

import type { EventCategory } from '@cobliteam/common-types';

import { Analytics } from '@cobliteam/analytics';

import { DefaultInput } from '@cobliteam/base-components';

import Icon from '@cobliteam/ui/icons';

interface FeedbackModalProps {
  trackEventName: string;
  descriptionText: string;
  eventCategory: EventCategory;
}

const FeedbackModal = ({ trackEventName, descriptionText, eventCategory }: FeedbackModalProps) => {
  const [feedback, setFeeback] = useState<string>('');

  const handleTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newText = event.target.value;
    setFeeback(newText);
  };

  const handleFormSubmit = () => {
    Analytics.track(trackEventName, { feedback, eventCategory });
    Alert.success('Sua opinião foi enviada com sucesso');
  };

  return (
    <>
      <Dialog>
        <Dialog.Trigger>
          <Button variant='link' color='primary' startIcon={<Icon name='megaphone' />}>
            Enviar opinião
          </Button>
        </Dialog.Trigger>

        <Dialog.Portal>
          <Dialog.Content modalSize='md'>
            <Dialog.Header>
              <Dialog.Title>Enviar opinião</Dialog.Title>
              <Dialog.Close />
            </Dialog.Header>

            <Dialog.Body className='my-3 space-y-3'>
              <Typography variant='input-label' color='secondary'>
                {descriptionText}
              </Typography>
              <DefaultInput className='flex h-32 items-start text-start' placeholder='Escreva sua opinião aqui' onChange={handleTextAreaChange} type='text' />
            </Dialog.Body>

            <Dialog.Footer className='flex justify-end gap-2.5'>
              <Dialog.Close asChild>
                <Button variant='text' color='primary'>
                  Cancelar
                </Button>
              </Dialog.Close>
              <Dialog.Close asChild>
                <Button startIcon={<Icon name='send-horizontal' />} variant='contained' color='primary' onClick={handleFormSubmit}>
                  Enviar opinião
                </Button>
              </Dialog.Close>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog>
    </>
  );
};

export default FeedbackModal;
